import { httpClient } from "../httpClient";
import {
  IDialogueTone,
  PaginatedResponse,
  UserVoiceQuery,
  PaginationQuery,
  CreateUserVoiceRequest,
  UpdateUserVoiceRequest,
} from "@packages/global";

/**
 * 个人音色 API 模块
 * 处理用户个人音色管理操作
 */
export class VoiceApi {
  /**
   * 获取个人音色分页列表
   */
  async getMyVoices(
    queryData: PaginationQuery<UserVoiceQuery>,
  ): Promise<PaginatedResponse<IDialogueTone>> {
    return httpClient.post<PaginatedResponse<IDialogueTone>>(
      "/user/dialogueTones/my-voices",
      queryData,
    );
  }

  /**
   * 创建个人音色
   */
  async createVoice(data: CreateUserVoiceRequest): Promise<IDialogueTone> {
    return httpClient.post<IDialogueTone>("/user/dialogueTones", data);
  }

  /**
   * 更新个人音色
   */
  async updateVoice(
    id: string,
    data: UpdateUserVoiceRequest,
  ): Promise<IDialogueTone> {
    return httpClient.put<IDialogueTone>(`/user/dialogueTones/${id}`, data);
  }

  /**
   * 删除个人音色
   */
  async deleteVoice(id: string): Promise<void> {
    return httpClient.delete<void>(`/user/dialogueTones/${id}`);
  }
}

// 导出单例实例
export const voiceApi = new VoiceApi();
